<template>
  <div class="response card" :id="'review_'+review.id">


    <div class="header">
      <span class="badge bg-danger badge-new" v-if="review.new">Новый</span>
      <div class="info">
        <div class="resource">
                  <span class="img" v-if="review.link.resource.ico"
                        :style="{backgroundImage: `url(${ review.link.resource.ico})`}"></span>
          <span class="img no-image" v-else
                :style="{backgroundColor: review.link.resource.color + '20', color: review.link.resource.color}">
              {{ $getShortName(review.link.resource.name) }}
            </span>

        </div>
        <div class="review-info">
          <div class="line rating">
            <b class="domain">{{ review.link.resource.domain }}</b>

            <div class="star-rating" :data-rating="review.rating">
              <div class="stars-container">
                <svg class="stars-background" viewBox="0 0 100 20">
                  <path d="M10,3 L12,8 L17,8 L13,11 L14,16 L10,13 L6,16 L7,11 L3,8 L8,8 Z"
                        fill="none" stroke="#f5da11" stroke-width="0.6"/>
                  <path d="M30,3 L32,8 L37,8 L33,11 L34,16 L30,13 L26,16 L27,11 L23,8 L28,8 Z"
                        fill="none" stroke="#f5da11" stroke-width="0.6"/>
                  <path d="M50,3 L52,8 L57,8 L53,11 L54,16 L50,13 L46,16 L47,11 L43,8 L48,8 Z"
                        fill="none" stroke="#f5da11" stroke-width="0.6"/>
                  <path d="M70,3 L72,8 L77,8 L73,11 L74,16 L70,13 L66,16 L67,11 L63,8 L68,8 Z"
                        fill="none" stroke="#f5da11" stroke-width="0.6"/>
                  <path d="M90,3 L92,8 L97,8 L93,11 L94,16 L90,13 L86,16 L87,11 L83,8 L88,8 Z"
                        fill="none" stroke="#f5da11" stroke-width="0.6"/>
                </svg>
                <div class="stars-foreground" :style="{'--rating': review.rating}">
                  <svg viewBox="0 0 100 20" preserveAspectRatio="none">
                    <path d="M10,3 L12,8 L17,8 L13,11 L14,16 L10,13 L6,16 L7,11 L3,8 L8,8 Z" fill="#f5da11"/>
                    <path d="M30,3 L32,8 L37,8 L33,11 L34,16 L30,13 L26,16 L27,11 L23,8 L28,8 Z" fill="#f5da11"/>
                    <path d="M50,3 L52,8 L57,8 L53,11 L54,16 L50,13 L46,16 L47,11 L43,8 L48,8 Z" fill="#f5da11"/>
                    <path d="M70,3 L72,8 L77,8 L73,11 L74,16 L70,13 L66,16 L67,11 L63,8 L68,8 Z" fill="#f5da11"/>
                    <path d="M90,3 L92,8 L97,8 L93,11 L94,16 L90,13 L86,16 L87,11 L83,8 L88,8 Z" fill="#f5da11"/>
                  </svg>
                </div>
              </div>

              <b class="rating-value">{{ review.rating }}</b>
            </div>

          </div>
          <div class="line">
                <span class="date-response">{{
                    review.city
                  }}</span><b class="date-response">&bull;</b>
            <span class="date-response" v-if="review.date_response" :data-date="review.date_response">
                  {{ $moment(review.date_response).format("DD.MM.YY HH:mm") }}
                </span>
            <span class="date-response" v-else-if="review.date_create" :data-date="review.date_create">
                  {{ $moment(review.date_create).format("DD.MM.YY HH:mm") }}
                </span>

          </div>
        </div>

        <a v-if="review.review_id && review.review_id.indexOf('http')+1" :href="review.review_id" target="_blank"
           class="badge external-link"><i
            class="bi bi-box-arrow-up-right"></i> ссылка на отзыв
        </a>

        <a v-else :href="review.link.link" target="_blank"
           class="badge external-link"><i
            class="bi bi-box-arrow-up-right"></i> ссылка на карточку
        </a>

      </div>
      <div class="rating">
        <!--        <button class="btn btn-sm btn-primary" :disabled="isSending" @click="sendReply" v-if="!review.answer_status && show_answered && $store.getters.user.is_staff">Отправить ответ</button>-->
        <div class="badge" v-if="review.our"
             :style="{backgroundColor: $COLORS['our'] + '20', color: $COLORS['our']}">
          {{ $store.getters.currentProject.name_for_our || "Отмечен" }}
        </div>
        <div class="badge" v-if="review.tone"
             :style="{backgroundColor: $COLORS[review.tone] + '20', color: $COLORS[review.tone]}">
          {{ review.get_tone_display }}
        </div>
        <div class="badge" v-if="review.content.responses.length"
             :style="{backgroundColor: $COLORS['positive_manual_new'] + '20', color: $COLORS['positive_manual_new']}">
          С ответом
        </div>
        <div class="badge" v-else
             :style="{backgroundColor: $COLORS['irrelevant'] + '20', color: $COLORS['irrelevant']}">
          Без ответа
        </div>
        <template v-if="$store.getters.currentProject.user_id === $store.getters.user.id && show_answered">
          <div class="answer-status">
            <span>Статус ответа:</span>
            <span :class="'badge bg-'+(review.answer_status==='answered'?'success':(review.answer_status==='error'||!review.answer_status)?'danger':'warning')">{{ review.get_answer_status_display||"не обработано" }}</span>
          </div>
          <a
             :class="'btn btn-sm btn'+(!review.answered?'-outline':'')+'-dark answered'"
             href="" title="Отметить наличие ответа"
             @click.prevent="review.answered = !review.answered;saveReview(review)">
            <i class="bi bi-check-circle-fill"></i> Отвечено</a>
        </template>
        <template v-else>

        </template>

        <a v-if="$store.getters.currentProject.user_id === $store.getters.user.id" href="" title="Отметить отзыв"
           @click.prevent="review.mark = !review.mark;saveReview(review)"><i
            :class="`bi text-danger bi-bookmark-check${review.mark?'-fill':''}`"></i></a>
        <a v-if="$store.getters.currentProject.user_id === $store.getters.user.id" href="" title="Добавить пометку"
           @click.prevent="$modal('show', 'review_comment'+review.id)"><i
            :class="`bi text-primary bi-chat-square-text${review.comment?'-fill':''}`"></i></a>

      </div>
    </div>
    <p class="text">{{ review.content?.text }}</p>
    <div class="tags">
      <div class="badge" v-for="tag in review.tags" :style="{backgroundColor: tag.color + '20', color: tag.color}">
        {{ tag.name }}
        <a v-if="$store.getters.currentProject.user_id === $store.getters.user.id" href=""
           @click.prevent="delete_tag = tag; $modal('show', 'delete_tag');"><i
            class="bi bi-x"></i></a>
      </div>
      <div class="tag-form" v-if="$store.getters.currentProject.user_id === $store.getters.user.id">
        <div class="dropdown">
          <button class="btn btn-secondary dropdown-toggle btn-sm" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
            <i class="bi bi-plus-lg"></i>
          </button>
          <ul class="dropdown-menu">
            <li class="search">
              <input type="text" v-model="tag_query" placeholder="поиск по названию">
            </li>
            <li v-for="tag in review_tags">
              <a href="" @click.prevent="review.tags.push(tag); saveReview(review)" class="badge"
                 :style="{backgroundColor: tag.color + '20', color: tag.color}">
                {{ tag.name }}
              </a>
            </li>
          </ul>
        </div>

      </div>
    </div>
    <modal :modal_id="'review_comment'+review.id">
      <template v-slot:header>
        <h4>Настройка комментария</h4>
      </template>
      <template v-slot:body>

        <div class="form-item">
              <textarea v-model="review.comment" class="form-control" placeholder="Заметка к отзыву"
                        :ref="`review_comment_`+review.id"></textarea>
        </div>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'review_comment'+review.id)"
                data-bs-dismiss="modal">Отмена
        </button>
        <button type="button" class="btn btn-success"
                @click="saveReview(review);$modal('hide', 'review_comment'+review.id);"
                data-bs-dismiss="modal">Сохранить
        </button>
      </template>
    </modal>


    <div class="answers">
      <div class="answer border-start border-primary rounded border-3" v-for="answer in review.content?.responses">
        <div class="line">
          <i class="bi bi-arrow-90deg-left text-primary"></i> <b>Ответ</b>

          <span class="date-response" v-if="answer.date">
                {{ $moment(answer.date).format("DD.MM.YY HH:mm") }}
              </span>
        </div>
        <p class="text">
          {{ answer.text }}
        </p>
      </div>
    </div>
    <modal modal_id="delete_tag">
      <template v-slot:header>
        <h4>Удаление тега</h4>
      </template>
      <template v-slot:body>

        <h6 v-if="delete_tag"><strong>Вы уверены, что хотите удалить тег "{{ delete_tag.name }}"?</strong></h6>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'delete_tag')"
                data-bs-dismiss="modal">Отмена
        </button>
        <button type="button" class="btn btn-danger" @click="deleteTag();$modal('hide', 'delete_tag');"
                data-bs-dismiss="modal">Удалить
        </button>
      </template>
    </modal>
  </div>

</template>

<script>

import {ReviewApi} from "@/api/reviews";
import {AdminApi} from "@/api/admin";

export default {
  name: 'SmallReview',
  props: {
    review: {type: Object},
    tags: {type: Array},
    show_answered: {type: Boolean, default: false},
  },
  data() {
    return {
      delete_tag: null,
      tag_query: "",
      isSending: false,
    }
  },
  watch: {},
  mounted: function () {

  },
  computed: {
    review_tags() {
      return this.tags.filter(tag => tag.name.toLowerCase().includes(this.tag_query.toLowerCase()))
    },
  },

  methods: {
    deleteTag() {
      this.review.tags.splice(this.review.tags.findIndex(x => x.id === this.delete_tag.id), 1);
      this.saveReview()
      this.delete_tag = null;
      this.$modal('hide', 'delete_tag');
    },
    // sendReply(){
    //    if (this.isSending) return;
    //    this.isSending = true;
    //   AdminApi.manual_send_autoreply({review_id: this.review.id}).then(response=>{
    //     const field_name = response.success?'success':'error'
    //     this.$notify({
    //       type: field_name,
    //       text: response[field_name] || 'Произошла ошибка при отправке'
    //     })
    //     if (response.review){
    //        this.$emit('update-review', {
    //           id: this.review.id,
    //           data: response.review
    //         });
    //     }
    //     this.isSending = false;
    //   })
    // },
    saveReview() {
      let data = JSON.parse(JSON.stringify(this.review))
      data.tags = data.tags.map(x => x.id);
      ReviewApi.update_review(this.review.id, data).then((response) => {
        this.review.answer_status = response.answer_status
        this.review.get_answer_status_display = response.get_answer_status_display
        this.$notify({
          type: "success",
          text: 'Сохранено'
        })

      })

    },
  }
}

</script>
<style scoped lang="scss">
.response {
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--soft-grey);
  margin: 0;

  .badge-new {
    position: absolute;
    top: -14px;
    height: auto;
    font-size: 13px;
  }

  .line {
    display: flex;
    gap: 5px;
    align-items: baseline;
  }

  .header {
    display: flex;
    justify-content: space-between;
    padding: 3px 0;

    .info {
      display: flex;
      gap: 10px;
    }

    .rating {
      display: flex;
      gap: 10px;
      align-items: center;

      .answered {
        height: 17px;
        font-size: 13px;
        padding: 1px 3px;
        line-height: normal;

        &:hover, &:focus {
          text-decoration: none;
        }

        &.btn-dark:focus {
          color: #fff;
        }

      }

      .badge {
        font-size: 10px;
      }

      .star-rating {
        display: inline-flex;
        align-items: center;
        font-size: 16px;

        .stars-container {
          position: relative;
          width: 100px;
          height: 20px;

          .stars-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }

          .stars-foreground {
            position: absolute;
            top: -2px;
            left: 0;
            width: calc(var(--rating) / 5 * 100%);
            height: 100%;
            overflow: hidden;

            svg {
              width: 100px;
              height: 100%;
            }
          }
        }

        .rating-value {
          font-size: 12px;
          margin-left: 5px;
          color: var(--dark-grey);
        }
      }


    }

    .external-link {
      background-color: rgba(0, 0, 0, 0.2);
      color: var(--dark-grey);
      height: 20px;
      margin-top: 10px;
    }


  }

  .text {
    color: var(--dark-grey);
    margin: 15px 0;
  }


  .date-response {
    font-size: 12px;
    color: var(--grey);
  }


  .answers {
    display: flex;
    flex-direction: column;
    gap: 15px;

    .answer {
      border-left: 1px solid #ccc;
      padding-left: 15px;

      .text {
        margin-top: 5px;
        font-size: 12px;
      }

    }
  }

}

@media (width < 768px) {


  .response {
    .header {
      flex-wrap: wrap;
    }

    .tags {
      flex-wrap: wrap;
    }
  }
}

.tags {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  position: relative;

  .tag-form {
    position: relative;

    .dropdown {
      .dropdown-menu {
        padding: 5px;

        .search {
          input {
            font-size: 12px;
            margin-bottom: 6px;
            width: 100%;
          }
        }
      }

      .dropdown-toggle {
        font-size: 12px;
        padding: 0 3px;

        &::after {

          display: none;
        }
      }
    }
  }
}

.highlight-effect {
  animation: clip-reveal-with-bg 1.2s ease-out forwards;
  position: relative;
  border-radius: 4px;
}

.answer-status {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 10px;
}

@keyframes clip-reveal-with-bg {
  0% {
    clip-path: inset(0 100% 0 0);
    background: linear-gradient(90deg, #ecdd86 0%, #f3e279 100%);
    background-repeat: no-repeat;
    background-size: 0 100%;
  }
  30% {
    clip-path: inset(0 0 0 0);
    background-size: 100% 100%;
  }
  70% {
    background-size: 100% 100%;
    background-color: rgba(255, 235, 59, 0.3);
  }
  100% {
    clip-path: inset(0 0 0 0);
    background-size: 0 100%;
    background-color: transparent;
  }
}

</style>

